<div #subscriberContainer  class="subscriber-container">
    <span class="user-wrapper" [class.is-active]="isActive">
        {{ subscriberInitials }}
    </span>
</div>